/**
 * Route Dependencies
 */
const Account = r => require.ensure([], () => r(require('../components/account/views/Account')), 'account')
const MyProfile = r => require.ensure([], () => r(require('../components/account/views/MyProfile')), 'account')
const AccountSettings = r => require.ensure([], () => r(require('../components/account/views/AccountSettings')), 'account')
const AccountPreferences = r => require.ensure([], () => r(require('../components/account/views/AccountPreferences')), 'account')
const AccountSubscription = r => require.ensure([], () => r(require('../components/account/views/AccountSubscription')), 'account')
const AccountUserManagement = r => require.ensure([], () => r(require('../components/account/views/AccountUserManagement')), 'account')
const AccountPasswordManagement = r => require.ensure([], () => r(require('../components/account/views/AccountPasswordManagement')), 'account')

/**
 * Account Routes
 */
export default {
    path: 'account',
    component: Account,
    children: [
        {
            path: '',
            name: 'account',
            component: MyProfile
        },
        {
            path: 'settings',
            name: 'account.settings',
            component: AccountSettings
        },
        {
            path: 'preferences',
            name: 'account.preferences',
            component: AccountPreferences
        },
        {
            path: 'subscription',
            name: 'account.subscription',
            component: AccountSubscription
        },
        {
            path: 'change-password',
            name: 'account.passwordManagement',
            component: AccountPasswordManagement
        },
        {
            path: 'user-management',
            name: 'account.users',
            component: AccountUserManagement
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/account.js